import type { CatalogResponse } from '@nadoutong/contracts';
import { useQuery } from '@tanstack/react-query';
import type { UseQueryResult } from '@tanstack/react-query';
import { useSession } from '../hooks/useSession.tsx';
import { getCatalog } from './catalog.ts';

export const CATALOG_QUERY_KEY = ['catalog'] as const;

/**
 * Nadoutong-pinned catalog query. Query key + staleTime match the
 * previous shared `useCatalogForBrand('nadoutong')` wiring exactly.
 */
export function useCatalog(): UseQueryResult<CatalogResponse> {
  const { fetchImpl } = useSession();
  return useQuery({
    queryKey: CATALOG_QUERY_KEY,
    queryFn: ({ signal }) => getCatalog(fetchImpl, signal),
    staleTime: 300_000,
  });
}
